<template>
  <b-container fluid class="p-0">

    <div class="text-center" v-if="product.variation == 0">
      <b-container fluid v-if="product.quantity > 0 || product.quantity == null " class="p-0 m-0">
        <b-container fluid v-if="isProductActive(product)" class="p-0 m-0 justify-content-center text-center">

          <b-row class="p-0 justify-content-center text-center">
            <a href="javascript:void(0)"
               class="add-to-cart text-center text-dark mb-2 p-1 px-2 text-center text-decoration-none"
               @click="basketAddItem(product)" v-if="!checkOrder(product) && IsAuthenticated">
              <b-icon icon="basket-fill"/>
            </a>
            <a href="javascript:void(0)"
               class="add-to-cart text-center px-2 text-dark mb-2 p-1 text-center text-decoration-none"
               @click="handleAddUnAuthItem(product)" v-if="!IsAuthenticated && !checkUnAuthBasket(product)">
              <b-icon icon="basket-fill"/>
            </a>
            <div class=""
                 v-if="!IsAuthenticated && checkUnAuthBasket(product)">
              <a href="javascript:void(0)" class="control-btn shadow"
                 @click="increaseUnAuthProductNumber(product)">
                <b-icon icon="plus"/>
              </a>

              <span :id="findHashProductOnLocalStorage(product)+'-col'"
                    class="mx-2 p-1 bg-light rounded text-dark text-center">{{
                  getUnAuthQuantityNumber(product)
                }}</span>

              <a href="javascript:void(0)" class="control-btn shadow"
                 @click="decreaseUnAuthProductNumber(product)"
                 v-if="getUnAuthQuantityNumber(product)>1">
                <b-icon icon="dash"/>
              </a>
              <a href="javascript:void(0)" class="control-btn shadow disabled" v-else>
                <b-icon icon="dash"/>
              </a>

              <b-button class="rounded " variant="transparent" @click="removeFromUnAuthOrder(product)">
                <b-icon variant="danger" class="p-0 mb-1" icon="cart-x-fill"/>
              </b-button>

            </div>
          </b-row>

          <div class="justify-content-center p-0 w-100 text-center"
               v-if="checkOrder(product) && IsAuthenticated">

            <b-button class="q-link border-0 m-1 p-1" @click="basketAddItem(product)">+</b-button>
            <span class="m-1 px-2 py-2 q-link bg-light rounded text-dark">{{ getQuantity(product.id) }}</span>

            <b-button class="q-link border-0 m-1 p-1"
                      @click="changeItemQuantity(product, getQuantity(product.id), basket)"
                      v-if="getQuantity(product.id)>1">-
            </b-button>
            <b-button class="q-link border-0 m-1 p-1"
                      @click="changeItemQuantity(product, getQuantity(product.id), basket)" v-else disabled>-
            </b-button>

            <b-button class="rounded p-0 mb-1" variant="transparent" @click="removeFromOrder(product, basket)">
              <b-icon variant="danger" icon="cart-x-fill"/>
            </b-button>

          </div>

        </b-container>

        <b-container v-else class="py-2 m-0">
          <b-row>
            <b-col>
              <span class="text-dark">زمان سفارش این محصول به پایان رسیده</span>
            </b-col>
          </b-row>
        </b-container>
      </b-container>

      <b-container fluid v-else class="py-2 px-0 m-0">
        <b-row align-v="center" align-h="center" class="text-center">
          <span class="text-muted font-weight-bold run-out-text">موجود نیست</span>
        </b-row>
      </b-container>
    </div>
    <div class="col-lg-12 text-center" v-if="product.variation == 1">
      <router-link class="add-to-cart text-center text-dark mb-2 p-1 px-2 text-center text-decoration-none"
                   :to="{name:'Product',params:{name:product.raw_link}}">مشاهده و خرید
      </router-link>

    </div>

  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {addUnAuthItem, basketAddItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {findHashProductOnLocalStorage} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';

export default {
  name: "ShoppingCartController1",
  props: ['product'],
  computed: {
    ...mapGetters({
      basket: "ShoppingCart/getSidebarBasketData",
    }),
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
  },
  methods: {
    formatNumber,
    isProductActive,
    basketAddItem,
    addUnAuthItem,
    findHashProductOnLocalStorage,
    checkOrder(product) {
      let result = false;
      if (this.basket.items !== undefined) {
        this.basket.items.forEach(item => {
          if (item.product.id === product.id) {
            result = true
          }
        })
      }
      return result
    },
    getQuantity(id) {
      let quantity = 0
      this.basket.items.forEach(item => {
        if (item.product.id === id) {
          quantity = item.quantity
        }
      })
      return quantity
    },
    getOrderItemId(product) {
      let itemId = 0
      this.basket.items.forEach(item => {
        if (item.product.id === product.id) {
          itemId = item.id
        }
      })
      return itemId
    },
    changeItemQuantity(product, quantity, basket) {
      this.$store.dispatch("ShoppingCart/updateItem", {
        order_product_id: this.getOrderItemId(product),
        quantity: quantity - 1,
        basket_id: basket.id
      })
    },
    removeFromOrder(product, basket) {
      this.$store.dispatch("ShoppingCart/removeItem", {
        order_product_id: this.getOrderItemId(product),
        basket_id: basket.id
      })

    },
    checkUnAuthBasket(product) {
      if (localStorage.getItem('products') !== null) {
        return this.findHashProductOnLocalStorage(product) != undefined;
      } else {
        return false
      }
    },
    /* un-auth shopping cart management */
    getUnAuthQuantityNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      return products[this.findHashProductOnLocalStorage(product)]['quantity']
    },
    increaseUnAuthProductNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      products[this.findHashProductOnLocalStorage(product)]['quantity']++;
      localStorage.setItem('products', JSON.stringify(products));
      this.$forceUpdate();
    },
    decreaseUnAuthProductNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      if (products[this.findHashProductOnLocalStorage(product)]['quantity'] > 1) {
        products[this.findHashProductOnLocalStorage(product)]['quantity']--;
      }
      localStorage.setItem('products', JSON.stringify(products));
      this.$forceUpdate();
    },
    removeFromUnAuthOrder(product) {
      let products = JSON.parse(localStorage.getItem('products'));

      delete products[this.findHashProductOnLocalStorage(product)];
      let elementId = this.findHashProductOnLocalStorage(product) + '-col'
      document.getElementById(elementId).remove();
      localStorage.setItem('products', JSON.stringify(products));
      this.$forceUpdate();
    },
    handleAddUnAuthItem(product) {
      this.addUnAuthItem(product)
      this.$forceUpdate();
    }
  },

}
</script>

<style scoped>
.q-link {
  height: 25px;
  line-height: 10px;
  background-color: var(--primary);
  color: var(--light);
}

.control-btn {
  text-decoration: none;
  padding: 0 3px 0;
  margin: 0;
  color: white;
  font-weight: bold;
  width: max-content;
  height: max-content;
  border-radius: 100%;
  background-color: var(--primary) !important;
}

.add-to-cart {
  border-radius: 15px;
  background-color: var(--primary) !important;
  color: white !important;
}

.add-to-cart:hover {
  border-radius: 15px;
  background-color: var(--primary) !important;
  color: white !important;
}

.run-out-text {
  font-size: 13px;

}
</style>